/**
 * Escapes user-controlled string values for safe interpolation into HTML.
 * Covers all five characters that can break HTML structure or introduce XSS:
 * & < > " '
 */
export function escapeHtml(value: string): string {
    return value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
}
